module.exports = __webpack_public_path__ + "img/alitas_de_pollo.e9dc3800.jpg";